module.exports = __webpack_public_path__ + "assets/42f6801f09e4e247fd24edff9730fc8f.png";